// extracted by mini-css-extract-plugin
export default {"root":"classes_root__Vfhb1","title":"classes_title__+Lddg","tabs-container":"classes_tabs-container__0sE+O"};